/**
 * Comparacion de texto para los buscadores dentro de una lista (categorias,
 * marcas del panel): sin mayusculas ni tildes, porque "Ferreteria" tiene que
 * encontrar "Ferretería".
 */
export function normalizarTexto(texto: string): string {
  return texto
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim();
}

export function contieneTexto(texto: string, buscado: string): boolean {
  return normalizarTexto(texto).includes(normalizarTexto(buscado));
}
